import { useLoyaltyPeriodDetail } from "features/LoyaltyPackage/data/hooks";
import { mapProductsForPackageDetail } from "features/LoyaltyPackage/data/mappers";

export default function usePackageDetail(periodId) {
  const { data: period, loading: periodLoading } = useLoyaltyPeriodDetail(periodId);

  const milestones = period?.milestones ?? [];
  const products = mapProductsForPackageDetail(period?.periodProducts, milestones);

  return {
    period,
    periodLoading,
    milestones,
    products,
    productsLoading: periodLoading,
  };
}
